/* eslint-disable no-case-declarations */
import { combineReducers } from 'redux';
import {
  FETCH_ORDER_BOOK_REQUEST,
  FETCH_ORDER_BOOK_SUCCESS,
  FETCH_ORDER_BOOK_FAILURE,
  CLEAR_ORDER_BOOK,
} from '../../constants/ActionTypes';

const duplicateInternalTagsExculeList = ['health-check-order:v2'];

const findUplicateInternalTags = (data = []) => {
  const duplicates = [];
  const all = [];

  data.forEach(({ internalTag = '' }) => {
    if (internalTag && !duplicateInternalTagsExculeList.includes(internalTag)) {
      if (!all.includes(internalTag)) {
        all.push(internalTag);
      } else if (!duplicates.includes(internalTag)) {
        duplicates.push(internalTag);
      }
    }
  });

  return duplicates;
};

const formatOrderBookData = (data = []) => {
  const duplicateInternalTags = findUplicateInternalTags(data);

  if (!data.length) {
    return data;
  }

  if (!duplicateInternalTags.length) {
    return data;
  }

  const formattedData = data.map((d) => {
    if (d.internalTag && duplicateInternalTags.includes(d.internalTag)) {
      d.internalTagIsDuplicate = true;
    }

    return d;
  });

  return formattedData;
};

const list = (
  state = {
    data: {},
    brokerDetails: {},
    isFetching: false,
    errorMessage: null,
  },
  action
) => {
  switch (action.type) {
    case FETCH_ORDER_BOOK_REQUEST:
      return {
        ...state,
        brokerDetails: action.brokerDetails,
        isFetching: true,
        errorMessage: null,
      };
    case FETCH_ORDER_BOOK_SUCCESS:
      const dataArray =
        action.data.data && action.data.data.data ? action.data.data.data : [];
      const dataArrayFormatted = formatOrderBookData(dataArray);

      action.data.data.data = dataArrayFormatted;

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_ORDER_BOOK_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    case CLEAR_ORDER_BOOK:
      return { ...state, data: {}, brokerDetails: {}, errorMessage: null };
    default:
      return state;
  }
};

const orderBook = combineReducers({
  list,
});

export default orderBook;
